<ng-container *ngIf="{
    row: columnData | async
} as $">
<span *ngIf="setCheckInEvent($.row.clt_chkin_event_type) !=null;else empty">{{ 'ADMIN.CHECK_IN.'+setCheckInEvent($.row.clt_chkin_event_type) | translate  }}
</span>
 <ng-template #empty>-</ng-template>
 </ng-container>